import { render, staticRenderFns } from "./DocumentTemplateList.vue?vue&type=template&id=c32d6bb8&"
import script from "./DocumentTemplateList.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports